/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditTag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function EditTag({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/NewTask/Content/Tags/Content/EditTag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tagsPickerEditTagOpenValueData = fromData.useDataValue({ viewPath,
context: 'tags_picker',
path: 'edit_tag.open',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(tagsPickerEditTagOpenValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}